<template>
  <div class="card mb-3">
    <div class="card-header" :id="'heading' + index">
      <div class="mb-0">
        <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse' + index" aria-expanded="true"
                :aria-controls="'collapse' + index">Home Insurance</button>
        <button class="btn mt-1 font-size-small text-color-grey float-right">{{ dateCreated }}</button>
      </div>
    </div>
    <div :id="'collapse' + index" class="collapse" :aria-labelledby="'headingFour' + index" data-parent="#accordion">
      <div class="card-body d-md-flex flex-md-wrap">
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Title : </span>
          <span>{{ data.title }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">First Name : </span>
          <span>{{ data.firstname }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Middle Name : </span>
          <span>{{ data.middlename }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Last Name : </span>
          <span>{{ data.lastname }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Marital Status : </span>
          <span>{{ data.maritalstatus }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Phone Number : </span>
          <span>{{ data.phonenumber }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Email : </span>
          <span>{{ data.email }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Country : </span>
          <span>{{ data.country }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Date of Birth : </span>
          <span>{{ data.datebirth }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Occupation : </span>
          <span>{{ data.occupation }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Address : </span>
          <span>{{ data.address }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Type of Home : </span>
          <span>{{ data.typehome }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Building Age : </span>
          <span>{{ data.buildingage }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Ownership Status : </span>
          <span>{{ data.ownershipstatus }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Starting Date of Insurance  : </span>
          <span>{{ data.insurancestart }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Type of Cover : </span>
          <span>{{ data.typecover }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsuranceViewHome',
  // Load props received from parent component to display insurance data
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    }
  },
  data () {
    return {
      dateCreated: null
    }
  },
  // convert date to a string using local settings
  created () {
    let date = new Date(this.data.created_on)
    this.dateCreated = date.toLocaleString()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/insurances/views/InsuranceViewHome.vue